var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolePropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0072,
    cy: 40.0072,
    r: 40.0072,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6281 52.8828V49.9757C51.6281 48.4337 51.0155 46.9548 49.9251 45.8644C48.8348 44.774 47.3559 44.1615 45.8138 44.1615H34.1853C32.6433 44.1615 31.1644 44.774 30.074 45.8644C28.9837 46.9548 28.3711 48.4337 28.3711 49.9757V52.8828",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9978 38.3473C43.209 38.3473 45.8121 35.7441 45.8121 32.533C45.8121 29.3219 43.209 26.7188 39.9978 26.7188C36.7867 26.7188 34.1836 29.3219 34.1836 32.533C34.1836 35.7441 36.7867 38.3473 39.9978 38.3473Z",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolePropIcon);
export default __webpack_public_path__ + "static/media/sole-prop_icon.5c22f4d2b4f4d6e2ac6a6e0d45ea5145.svg";
export { ForwardRef as ReactComponent };